





















import { Vue, Component, Prop } from 'vue-property-decorator';
import moduleStore from '../store/migu';
import to from 'await-to-js';
import { MiguConfig } from '../utils/constant';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class SubmitBtn extends Vue {
  @Prop({ default: false })
  isNewYear: boolean;
  @Prop({ default: false }) 
  isSubmiting: boolean;

  loaded = false; // 是否加载完毕
  needCredit = true; // 是否需要判断权益
  
  leftFreeCount = 0; // 剩余免费次数
  rightsCount = 0; // 权益次数
  needJumpPay = false; // 未通过鉴权，跳转付费页面
  
  get pathSuffix() { return this.$publicPath + 'images/migu/' + (this.isNewYear ? 'newYear/' : ''); }
  get freeIcon() { return this.pathSuffix + 'free_icon.png'; }
  get consumeIcon() { return this.pathSuffix + 'consume_icon.png'; }
  get infoIcon() { return this.pathSuffix + 'info_icon.png'; }
  get commonPub() { return this.$store.getters['miguPage/getCommonPub']; }
  
  // 判断权益是否已用完：需要判断权益并且（没有 commonPub 标识或 commonPub 标识为 false）时才检查 leftFreeCount 和 rightsCount
  get isCreditExhausted() {
    // 如果有 commonPub 标识，则不显示权益耗尽状态
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    // 没有 commonPub 标识时，按原有逻辑判断：needCredit 为 true 且 leftFreeCount 和 rightsCount 都为 0
    return commonPub && !this.leftFreeCount && !this.rightsCount;
  }

  async mounted() {
    if (this.needCredit) {
      this.queryUserRight();
    }
    this.loaded = true;
  }

  async queryUserRight() {
    const [err, res] = await to(this.$http('getRights'));
    if (err || res.code !== 200) {
      const commonPub = this.$store.getters['miguPage/getCommonPub'];
      if (commonPub) {
        localStorage.removeItem('btoken');
      }
      this.$toast('获取权益失败');
      return;
    }
    const { status, rightsCount, experienceCount } = res.data.data;
    // 是否鉴权通过 通过：1 不通过：0
    if(!status) {
      this.needJumpPay = true;
    }
    this.leftFreeCount = experienceCount;
    this.rightsCount = rightsCount;
  }
  
  handleSubmit() {
    const commonPub = this.$store.getters['miguPage/getCommonPub'];
    if (commonPub) {
      const btoken = localStorage.getItem('btoken');
      if (!btoken) {
        this.$emit('check-login');
        return;
      }
      // 权益已用完，禁止点击
      if (this.isCreditExhausted) {
        this.tryDirectJump();
        return;
      }
    }
    this.doSubmit();
  }
  
  doSubmit() {
    // 不需要判断权益
    if(!this.needCredit) {
      this.doCreateSubmit();
      return;
    }
    if(this.needJumpPay) {
      this.$emit('jump-pay');
      return;
    }
    // 需要判断权益，获取taskId，有剩余次数时直接提交，否则是升级权益
    this.$emit('query-task', this.leftFreeCount || this.rightsCount);
  }
  doCreateSubmit() {
    if (this.isSubmiting) return;
    this.$emit('submit');
  }
  // 跳转到咪咕彩媒小程序的方法
  tryDirectJump() {
    alert("您暂无可使用权益，请先去咪咕彩媒小程序或咪咕音乐APP订购！");
    // const target = "#小程序://咪咕彩媒/efCLd8WJ9auQ6po";
    // if (/micromessenger/i.test(navigator.userAgent)) {
    //   window.location.href = target;
    // } else {
    //   alert("请在微信客户端中打开此链接");
    // }
    // console.log('tryDirectJump', target);
  }

  showOrderTip() {
    // 显示订阅明细
    window.location.href = 'https://y.migu.cn/app/mp/migu-aigc/h5/index.html?_debug=1#/pages/use-detail/index';
  }
}
